import React from 'react'
// import PropTypes from 'prop-types'
import mapStyles from '../../styles/tracker-modules/rateMap.module.less'
import { scaleLinear } from 'd3-scale'
import { capfirst } from 'journalize'

function MapLegend({ activeKey, min, max, label, width, colorScale }) {
  const labelScale = (val) => {
    let range = [0, width]

    const innerScale = scaleLinear().domain([min, max]).range(range)

    return innerScale(val)
  }
  const pctTicks = [0, 0.25, 0.5, 0.75, 1]

  let capitaTicks = [
    min,
    Math.round(max * 0.25),
    Math.round(max * 0.5),
    Math.round(max * 0.75),
    Math.round(max),
  ]

  let ticks = activeKey.key === 'a/100k' ? capitaTicks : pctTicks

  return (
    <div style={{ maxWidth: `${width}px`, margin: 'auto' }}>
      <div className={mapStyles.legendHed}>{capfirst(label)}</div>
      <div
        style={{
          backgroundImage: `linear-gradient( to right, ${colorScale(
            activeKey,
            min,
            min,
            max
          )}, ${colorScale(activeKey, max, min, max)})`,
          width: `${width}px`,
        }}
        className={mapStyles.gradient}
      >
        {
          //add white bar
          ticks.map((tick, i) => {
            if (i === 0 || i === ticks.length - 1) {
              return null
            }
            const left = labelScale(tick)
            return (
              <div
                className={mapStyles.tickMark}
                key={'tickmark' + left}
                style={{ left: `${left}px` }}
              ></div>
            )
          })
        }
      </div>

      <div className={mapStyles.ticks}>
        {ticks.map((tick, i) => {
          let num = activeKey.format === 'percent' ? tick * 100 : tick
          let numStr =
            activeKey.format === 'percent'
              ? tick.toLocaleString('en-US', {
                  style: 'percent',
                })
              : num.toLocaleString()
          // center ticks on tick marks
          const offset = 4 * String(num).length + 1
          const left = labelScale(tick) - offset

          return (
            <div
              className={mapStyles.tick}
              key={'tick' + num}
              style={{ left: `${left}px` }}
            >
              {numStr}
            </div>
          )
        })}
      </div>
    </div>
  )
}

// RateMap.propTypes = {}

export default React.memo(MapLegend)
